import axios from "axios";
import { saveAs } from 'file-saver';
import React, { useState, useEffect, useContext } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { IconButton, Snackbar, TextField, Box, Button } from "@mui/material";
import ProfileCaseListTable from "../../components/ProfileCaseListTable/ProfileCaseListTable";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import FilterMenu from "../../components/FilterMenu/FilterMenu";
import "./CaseList.css";
import AllocateMenu from "../../components/AllocateMenu/AllocateMenu";
import { useParams, useLocation } from "react-router-dom";
import EnterpriseMenu from "../../components/EnterpriseMenu/EnterpriseMenu";
import {
  caseListPaginationInfo,
  profileType,
  URL,
  roleType,
  caseStatus,
  userType,
  caseDefaultFilters
} from "../../constants/constant";
import FilterContext from "../../components/StateManagement/Context";

const Caselist = ({ role }) => {
  const { caseListFilters, updateCaseFilters } = useContext(FilterContext);
  const [rows, setRows] = useState([]);
  const [caseListPaginationProperties, setCaseListPaginationProperties] = useState({});

  //getting role and user to specify how the table should look like by default.
  const loggedInUser = JSON.parse(
    localStorage.getItem("loggedInUserDetails")
  ).emailId.split("@")[0];

  const [allUsers, setAllUsers] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [dataLoading, setDataLoading] = useState(false);
  const [searchId, setSearchId] = useState("");
  const [message, setMessage] = useState();
  const [openSnackbar, setOpenSnackBar] = useState(false);
  const [enterprises, setEnterprises] = useState([]);

  // const [filterStatus, setFilterStatus] = useState(
  //   role === roleType.Admin ? caseStatus.dataEntryPending : caseStatus.allPending
  // );
  // const [filterUser, setFilterUser] = useState(
  //   role === roleType.Admin ? userType.all : loggedInUser
  // );

  const { profile } = useParams();
  const search = useLocation();
  const searchParams = new URLSearchParams(search.search);
  const [profileInfo, setProfileInfo] = useState({
    profile: profile,
    profileName: searchParams.get("profileName")
  });

  const [caseListType, setCaseListType] = useState();
  
  //snackbar
  const handleSnackbar = () => {
    setOpenSnackBar(true);
  };

  const handleCloseSnackbar = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnackBar(false);
  };

  const action = (
    <React.Fragment>
      <IconButton
        size="small"
        aria-label="close"
        color="inherit"
        onClick={handleCloseSnackbar}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </React.Fragment>
  );

  //search
  const handleSearch = () => {
    if (!isNaN(searchId)) {
      searchFromId();
    } else {
      setMessage(`Enter a valid ID`);
      handleSnackbar();
    }
  };

  const searchFromId = () => {
    setDataLoading(true);
    var data = JSON.stringify({
      caseId: Number(searchId),
      status: "",
      allocatedUser: loggedInUser,
      role: role,
    });

    var config = {
      method: "post",
      url: URL.demystify_url + "basicCaseData/fetchCases-v2/",
      headers: {
        accept: "application/json",
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(config)
      .then(function (response) {
        //console.log(JSON.stringify(response.data));
        response.data.cases.forEach((caseObj, index) => {
          caseObj["id"] = index;
        });
        setRows(response.data.cases);
        setDataLoading(false);
      })
      .catch(function (error) {
        console.log(error);
        setDataLoading(false);
      });
  };

  const validateAllotment = (allocatedUser) => {
    if (selectedRows.length == 0) {
      setMessage(`No cases specified`);
      handleSnackbar();
    } else if (allocatedUser == "") {
      setMessage(`No user specified`);
      handleSnackbar();
    } else {
      let caseIds = [];
      selectedRows.map((row) => {
        caseIds.push(row.case_id);
      });
      handleAllotment(caseIds, allocatedUser);
    }
  };

  const handleAllotment = (caseIds, allocatedUser) => {
    let callApi = true;
    selectedRows.map((row) => {
      if (
        row.state == "INCOMPLETE" ||
        row.state == "VERIFIED" ||
        row.state == "REJECTED"
      ) {
        setMessage(`Status of selected row(s) cannot be '${row.state}' `);
        handleSnackbar();
        callApi = false;
      } 
      // else if (row.data_entry_users === allocatedUser) {
      //   setMessage(`Data entry user cannot be QC user`);
        // handleSnackbar();
      //   callApi = false;
      // }
    });

    if (callApi) {
      var data = JSON.stringify({
        cases: caseIds,
        allocateTo: allocatedUser,
      });

      var config = {
        method: "post",
        url: URL.demystify_url + "basicCaseData/allocateCases/",
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };

      axios(config)
        .then(function (response) {
          if (response.data.success == 1) {
            setMessage(`Successfully allocated to ${allocatedUser}`);
            handleSnackbar();
            fetchCaseList();
          } else if (response.data.success == 0) {
            setMessage(response.data.errMessage);
            handleSnackbar();
          } else {
            setMessage(response.data.errMessage);
            handleSnackbar();
          }
        })
        .catch(function (error) {
          alert(error);
          console.log(error);
        });
    }
  };

  useEffect(() => {
    const defaultFilters = getDefaultFiltersByPath();
    const profileName = searchParams.get("profileName");

    if (!caseListFilters.filterStatus) {
      const filterStatus = role == roleType.Admin ? caseStatus.dataEntryPending : caseStatus.allPending;
      updateCaseFilters("filterStatus", filterStatus);
    }

    if ([null, undefined].includes(caseListFilters.filterUser)) {
      const filterUser = role == roleType.Admin ? userType.all : loggedInUser;
      updateCaseFilters("filterUser", filterUser);
    }

    const profileInfo = {
      profile: defaultFilters.profile || profile,
      profileName: defaultFilters.profileName || profileName
    }
    updateCaseFilters("profileInfo", profileInfo);

    if (!caseListFilters.selectedEnterprise) {
      const selectedEnterprise = (profile === profileType.corporate ? profileName : profile) || defaultFilters.selectedEnterprise;
      updateCaseFilters("selectedEnterprise", selectedEnterprise)
    }

    fetchAllUsers();

    return () => {
      setRows([]);
    };
  }, [])

  useEffect(() => {
    if (caseListType){
      fetchEnterprises();
    }
  }, [caseListType]);

  useEffect(() => {
    if (
      caseListType &&
      caseListFilters.filterStatus &&
      ![null, undefined].includes(caseListFilters.filterUser)
    ) {
      fetchCaseList();
    }

    return (() => {
      setRows([]);
    })
  }, [
    caseListFilters.filterStatus, 
    caseListFilters.filterUser, 
    caseListFilters.selectedEnterprise,
    caseListFilters.profileInfo,
    caseListType
  ]);

  const validateRows = (chosenRows) => {
    setSelectedRows(chosenRows);
  };

  const exportFilteredData = (
    pageNumber = caseListPaginationInfo.defaultPageNumber,
    pageSize = caseListPaginationInfo.defaultPageSize
  ) => {
    setDataLoading(true);
    var data = JSON.stringify({
      status: caseListFilters.filterStatus,
      allocatedUser: caseListFilters.filterUser,
      userId: "",
      role: role,
      profile: caseListType === profileType.corporate ? caseListType : caseListFilters.profileInfo?.profile,
      profileName: caseListType === profileType.insurance ? profileType.dynamicSet : caseListFilters.profileInfo?.profileName,
      pageNo: pageNumber,
      pageSize: pageSize
    });

    var config = {
      method: "post",
      url: URL.demystify_url + "basicCaseData/fetchCases-v2/",
      headers: {
        accept: "application/json",
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(config)
      .then(function (response) {
        console.log(response.data.cases,"err")
        const csvData = jsonToCSV(response.data.cases);
        const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' });
        saveAs(blob, 'exportedData.csv');
        setDataLoading(false);
      })
      .catch(function (error) {
        console.log(error);
        setDataLoading(false);
      });
  };
  function jsonToCSV(json) {
    const items = json;
    const replacer = (key, value) => value === null ? '' : value;
    const header = Object.keys(items[0]);
    let csv = items.map(row => header.map(fieldName => JSON.stringify(row[fieldName], replacer)).join(','));
    csv.unshift(header.join(','));
    csv = csv.join('\r\n');
    return csv;
  }


  const fetchCaseList = (
    pageNumber = caseListPaginationInfo.defaultPageNumber,
    pageSize = caseListPaginationInfo.defaultPageSize
  ) => {
    setDataLoading(true);
    var data = JSON.stringify({
      status: caseListFilters.filterStatus,
      allocatedUser: caseListFilters.filterUser,
      userId: "",
      role: role,
      profile: caseListType === profileType.corporate ? caseListType : caseListFilters.profileInfo?.profile,
      profileName: caseListType === profileType.insurance ? profileType.dynamicSet : caseListFilters.profileInfo?.profileName,
      pageNo: pageNumber,
      pageSize: pageSize
    });

    var config = {
      method: "post",
      url: URL.demystify_url + "basicCaseData/fetchCases-v2/",
      headers: {
        accept: "application/json",
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(config)
      .then(function (response) {
        response.data.cases.forEach((caseObj, index) => {
          caseObj["id"] = index;
        });
        setRows(response.data.cases);
        setCaseListPaginationProperties({
          pageNumber: response.data.pageNumber,
          pageSize: response.data.pageSize,
          totalRowCount: response.data.totalDocCount,
        });
        setDataLoading(false);
      })
      .catch(function (error) {
        console.log(error);
        setDataLoading(false);
      });
  };

  const fetchEnterprises = () => {
    var config = {
      method: "get",
      url: URL.demystify_url + "basicCaseData/fetchEnterprises/",
      headers: {},
    };

    axios(config)
      .then(function (response) {
        if (caseListType == profileType.corporate) {
          setEnterprises(response.data.message.Corporate);
        }
        else if (caseListType == profileType.insurance) {
          setEnterprises(response.data.message.Insurance);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  const fetchAllUsers = () => {
    var config = {
      method: "get",
      url: URL.demystify_url + "auth/fetchAllUsers",
      headers: {
        accept: "application/json",
      },
    };

    axios(config)
      .then(function (response) {
        // console.log(response.data.users)
        setAllUsers(response.data.users);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  const fetchSelectedUsers = (status) => {
    let roleType = status == "All" ? "All Pending" : status 
    var data = {
      "roleType": roleType,
    }
    var config = {
      method: "post",
      url: URL.demystify_url + "auth/fetchSelectedUsers",
      headers: {
        accept: "application/json",
        "Content-Type": "application/json",
      },
      data: JSON.stringify(data)
    }

    axios(config)
      .then(function (response) {
        if (caseListType == profileType.insurance) {
          console.log("ins")
          setAllUsers(response.data.insuranceUsers);
        }
        else if (caseListType == profileType.corporate) {
          console.log("corp")
          setAllUsers(response.data.corpUsers);
        }
        
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  useEffect(()=>{
    if (caseListFilters.filterStatus) {
      fetchSelectedUsers(caseListFilters.filterStatus)
    }

  }, [caseListFilters.filterStatus])

  const handlePageChange = (pageNumber) => {
    fetchCaseList(pageNumber, caseListPaginationProperties.pageSize);
  }
  const handlePageSizeChange=async(pageSize)=>{
  
     fetchCaseList(1,Number(pageSize));
  }

  const handleEnterpriseChange = (updatedEnterprise) => {
    updateCaseFilters("selectedEnterprise", updatedEnterprise);
    updateCaseFilters("profileInfo", {
      profile: caseListType === profileType.corporate ? profileType.corporate : updatedEnterprise,
      profileName: caseListType === profileType.insurance ? profileType.dynamicSet : updatedEnterprise
    });
  }

  const getDefaultFiltersByPath = () => {
    const currentPath = search.pathname;
    let defaultFilters = {};

    if (currentPath.includes('corporatecaselist')) {
      defaultFilters = caseDefaultFilters.corporateCaseFilters;
      setCaseListType(profileType.corporate);
    }
    else if (currentPath.includes('insurancecaselist')) {
      defaultFilters = caseDefaultFilters.insuranceCaseFilters;
      setCaseListType(profileType.insurance);
    }
    else if (currentPath.includes('profiles')) {
      if (currentPath.includes('Corporate')) {
        setCaseListType(profileType.corporate);
      } else {
        setCaseListType(profileType.insurance);
      }
    }

    return defaultFilters;
  }
 const exportData=()=>{
  exportFilteredData(1,"MAX");
 }
  return (
    <div className="grid-container">
      <div className="grid-title">
        <h3>
          Case List
          {caseListFilters.profileInfo?.profile
            ? `: ${caseListFilters.profileInfo?.profile}  ${
                caseListFilters.profileInfo?.profileName || ""
              }`
            : ""}{" "}
        </h3>
      </div>
      <div className="grid-btns">
        <div>
          <Box display="flex">
            <TextField
              id="standard-basic"
              label="Search by Case Id"
              variant="filled"
              size="small"
              autoComplete="off"
              inputProps={{ style: { fontSize: 15, height: 10, width: 150 } }}
              InputLabelProps={{ style: { fontSize: 15 } }}
              value={searchId}
              onChange={(e) => {
                setSearchId(e.target.value);
              }}
              onKeyDown={(ev) => {
                if (ev.key === "Enter") {
                  handleSearch();
                }
              }}
            />

            <IconButton onClick={() => handleSearch()}>
              <SearchOutlinedIcon />
            </IconButton>
          </Box>
        </div>
        <div>
          <EnterpriseMenu
            enterprises={enterprises}
            needAll={true}
            handleEnterpriseChange={handleEnterpriseChange}
          />
        </div>
        <div>
          <FilterMenu
            role={role}
            loggedInUser={loggedInUser}
            allUsers={allUsers}
            statusFilter={caseListFilters.filterStatus}
            userFilter={caseListFilters.filterUser}
          />
        </div>
        <div style={{ display: role == "Admin" ? "" : "none" }}>
          <AllocateMenu
            validateAllotment={validateAllotment}
            allUsers={allUsers}
          />
        </div>
      </div>
      <div className="grid-table">
        <ProfileCaseListTable
          profileType={caseListType}
          data={rows}
          caseListPaginationProperties={caseListPaginationProperties}
          role={role}
          validateRows={validateRows}
          loading={dataLoading}
          handlePageChange={handlePageChange}
          handlePageSizeChange={handlePageSizeChange}
        />
         <Button style={{ display: role == "Admin" ? "" : "none" }} variant="contained" fullWidth={false} onClick={exportData}>
        Export All
        </Button>
      </div>

      <Snackbar
        open={openSnackbar}
        autoHideDuration={3000}
        onClose={handleCloseSnackbar}
        action={action}
        message={message}
      />
    </div>
  );
};

export default Caselist;
